<template>
  <v-container grid-list-xl>
    <v-row>
      <v-col cols="12">
        <v-progress-linear :indeterminate="true" v-if="statusLoading"></v-progress-linear>
        <v-alert v-else-if="statusError" type="warning" outlined>
          Nie udało się pobrać statusu certyfikatów P1. Odśwież stronę lub spróbuj ponownie później.
        </v-alert>
        <v-alert v-else-if="!status || !status.certificatesUploaded" type="info" outlined>
          Certyfikaty P1 (WSS i TLS) nie zostały jeszcze wgrane.
        </v-alert>
        <v-alert v-else :type="statusAlertType" :prominent="certsExpired || certsExpireSoon || certsUnreadable">
          <strong v-if="certsExpired">Certyfikaty P1 wygasły {{ formatDateTime(minExpiryDate) }}.</strong>
          <strong v-else-if="certsExpireSoon">Certyfikaty P1 niebawem wygasną — są ważne do {{ formatDateTime(minExpiryDate) }}.</strong>
          <strong v-else-if="certsUnreadable">Nie można odczytać daty ważności certyfikatów P1 (np. nieprawidłowe hasło). Wgraj certyfikaty ponownie.</strong>
          <strong v-else>Certyfikaty P1 są wgrane.</strong>
          <div class="mt-2">
            Certyfikat WSS ważny do: {{ status.wssExpiryDate ? formatDateTime(status.wssExpiryDate) : 'nie można odczytać daty ważności' }}<br>
            Certyfikat TLS ważny do: {{ status.tlsExpiryDate ? formatDateTime(status.tlsExpiryDate) : 'nie można odczytać daty ważności' }}
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>Wgrywanie certyfikatów P1</v-card-title>
      <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="uploading"></v-progress-linear>
        <v-row>
          <v-col cols="12" md="6">
            <v-file-input v-model="wssFile" label="Certyfikat WSS" accept=".p12,.pfx" prepend-icon="fa-paperclip" outlined></v-file-input>
          </v-col>
          <v-col cols="12" md="6">
            <v-file-input v-model="tlsFile" label="Certyfikat TLS" accept=".p12,.pfx" prepend-icon="fa-paperclip" outlined></v-file-input>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="password" label="Hasło do certyfikatów" :type="'password'" @keydown.enter.prevent="canUpload && !uploading ? upload() : null"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" :disabled="!canUpload || uploading" @click="upload">Wgraj certyfikaty</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import swal from "sweetalert";
import { mapActions } from "vuex";
import { settingsService } from "@/services/";
import dayjs from "dayjs";

export default {
  name: "P1Certificates",
  data() {
    return {
      status: null,
      statusLoading: false,
      statusError: false,
      wssFile: null,
      tlsFile: null,
      password: null,
      uploading: false
    }
  },
  computed: {
    canUpload() {
      return this.wssFile && this.tlsFile && this.password
    },
    minExpiryDate() {
      if (!this.status)
        return null
      let dates = [this.status.wssExpiryDate, this.status.tlsExpiryDate].filter(d => d)
      if (dates.length === 0)
        return null
      return dates.sort((a, b) => new Date(a) - new Date(b))[0]
    },
    certsExpired() {
      return this.minExpiryDate && dayjs(this.minExpiryDate).isBefore(dayjs())
    },
    certsExpireSoon() {
      return this.minExpiryDate && !this.certsExpired && dayjs(this.minExpiryDate).isBefore(dayjs().add(3, 'day'))
    },
    certsUnreadable() {
      return this.status && this.status.certificatesUploaded && (!this.status.wssExpiryDate || !this.status.tlsExpiryDate)
    },
    statusAlertType() {
      if (this.certsExpired)
        return 'error'
      if (this.certsExpireSoon || this.certsUnreadable)
        return 'warning'
      return 'success'
    }
  },
  methods: {
    ...mapActions("alert", ["success"]),
    formatDateTime(val) {
      if (!val) return ''
      return dayjs(val).format("DD-MM-YYYY HH:mm")
    },
    getStatus() {
      this.statusLoading = true
      this.statusError = false
      settingsService.getP1CertificatesStatus().then(resp => {
        this.status = resp.data.result
      }).catch(error => {
        console.log(error)
        this.statusError = true
      }).finally(() => {
        this.statusLoading = false
      })
    },
    upload() {
      let formData = new FormData()
      formData.append('wss', this.wssFile)
      formData.append('tls', this.tlsFile)
      formData.append('password', this.password)

      this.uploading = true
      settingsService.uploadP1Certificates(formData).then(response => {
        this.uploading = false
        this.status = response.data.result
        this.wssFile = null
        this.tlsFile = null
        this.password = null
        this.success("Certyfikaty P1 zostały wgrane")
      }).catch(error => {
        this.uploading = false
        let err = error.response
        if (err && err.data != null && err.data.error && err.data.error.message) {
          this.showError(err.data.error.message)
        } else {
          this.showError("Nie można wgrać certyfikatów")
        }
      })
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      })
    }
  },
  created() {
    this.getStatus()
  }
}
</script>

<style scoped>
</style>
